import React from 'react'

// material ui
import Container from '@mui/material/Container'

// components
import Typography from '@mui/material/Typography'
import NavButtons from 'components/register/shared/NavButtons'

const AccountCreated = props => {
  const { account, pathname } = props

  return (
    <>
      <Typography mb={2} variant='h4' align='center'>
        Hi, {account.user.firstName}!
      </Typography>

      <Container maxWidth='sm'>
        <Typography mb={4}>
          You are the main contact for this account, and the primary emergency
          contact. You can change your contact details in the "Parents" section.
        </Typography>
      </Container>

      <NavButtons account={account} pathname={pathname} />
    </>
  )
}

export default AccountCreated
